define('core/extensions/helpers/now',[
    'moment',
], function (
    moment
) {
    'use strict';

    // Get time now
    return function (format) {
        return moment().format(format);
    };
});

